import type React from 'react';

// JS-side seeds for palette generation only — keep in sync with widgets.css.
export const VISUAL_FRACTION_DISPLAY_COLOR = '#AE9CFF';
export const VISUAL_FRACTION_BORDER_COLOR = '#705DC0';

// ─── Part descriptor ──────────────────────────────────────────────────────────

/**
 * All data needed to render one visual fraction part (bar cell, circle sector,
 * or triangle sub-path).  Computed once and passed down to shape components so
 * the shapes stay stateless.
 */
export interface VisualFractionPart {
  /** Position index within the shape (0-based). */
  index: number;
  className: string;
  style: React.CSSProperties | undefined;
  /** True when this slot can be clicked by the user. */
  isInteractiveSlot: boolean;
  /** True when a group is assigned to this slot. */
  isSelected: boolean;
  /** Index into the answer/filled palette, or null when empty. */
  groupIndex: number | null;
}
